<template>
  <div class="agreement">
    <div class="content">
      <span>{{ $t('agreement.license') }}</span>
      <div>
        <doc></doc>
      </div>
      <el-form
        :model="agreeForm"
        :rules="agreeRule"
        ref="agreeForm"
        class="checkboxEl"
        size="small"
      >
        <el-form-item prop="checkeds">
          <el-checkbox v-model="agreeForm.checkeds">
            {{ $t('agreement.i.agree') }}
            <span>{{ $t('agreement.enterprise.agreement') }}</span>
          </el-checkbox>
        </el-form-item>
        <el-form-item prop="checked">
          <el-checkbox v-model="agreeForm.checked">
            {{ $t('agreement.i.agree.cloudcc') }}
            <span class="link" @click="toPrivacyPolicy">{{ $t('agreement.privacy.policy') }}</span>
            {{ $t('agreement.and') }}
            <span class="link" @click="toTermsOfService">{{ $t('agreement.terms.of.service') }}</span>
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button class="btnR" type="primary" @click="proceed"
          >{{ $t('agreement.apply.partner') }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { enablePartner } from "./api.js";
import doc from "./doc.vue"
export default {
  name: "index",
  components: { doc },
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        // 您必须同意CloudCC许可协议
        return callback(new Error(this.$i18n.t('agreement.must.agree.license')));
      } else {
        callback();
      }
    };
    var checkAges = (rule, value, callback) => {
      if (!value) {
        // 您必须同意CloudCC许可协议
        return callback(new Error(this.$i18n.t('agreement.must.agree.enterprise')));
      } else {
        callback();
      }
    };
    return {
      agreeForm: {
        checked: false,
        checkeds: false,
      },
      agreeRule: {
        checked: [{ validator: checkAge, trigger: "blur" }],
        checkeds: [{ validator: checkAges, trigger: "blur" }],
      },
    };
  },
  computed: {
    // 根据域名判断环境：com 为国外，cn 为国内
    isOverseas() {
      const host = window.location.hostname;
      return host.includes('.com');
    },
    privacyPolicyUrl() {
      return this.isOverseas
        ? 'https://cloudcc.com/company/privacy/'
        : 'https://informations.cloudcc.com/policy/PrivacyPolicy-zh.html';
    },
    termsOfServiceUrl() {
      return this.isOverseas
        ? 'https://cloudcc.com/company/terms/'
        : 'https://informations.cloudcc.com/policy/terms-zh.html';
    },
  },
  methods: {
    /** 取消 */
    cancel() {
      this.$emit("agreeCancel");
    },
    /** 同意 */
    proceed() {
      this.$refs.agreeForm.validate((valid) => {
        if (valid) {
          enablePartner({}).then((res) => {
            if (res.result) {
              this.$emit("agreeProceed");
            }
          });
        } else {
          return false;
        }
      });
    },
    toPrivacyPolicy() {
      window.open(
        this.privacyPolicyUrl,
        "_blank"
      );
    },
    toTermsOfService() {
      window.open(
        this.termsOfServiceUrl,
        "_blank"
      );
    },
  },
};
</script>

<style lang = "scss" scoped>
.agreement {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    width: 80%;
    /* height: 499px; */
    background: #ffffff;
    /* box-shadow: 2px 4px 24px 0px rgba(6, 68, 123, 0.12); */
    /* border-radius: 12px 12px 12px 12px; */
    & > span {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      line-height: 22px;
      display: inline-block;
      margin-bottom: 32px;
    }
    p,
    ul {
      font-size: 14px;
      font-weight: 400;
      color: #555555;
      line-height: 27px;
      word-break: break-word;
      li:before {
        content: "";
        width: 5px;
        height: 5px;
        display: inline-block;
        border-radius: 50%;
        background: #555555;
        vertical-align: middle;
        margin-right: 14px;
      }
    }
    .checkboxEl {
      margin: 24px 0 35px 0;
    }
    .link {
      color: #006dcc;
      cursor: pointer;
      text-decoration: underline;
    }
    .btn {
      display: flex;
      justify-content: center;
      .btnL {
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        padding: 10px 30px;
      }
      .btnR {
        background: #006dcc;
        box-shadow: 4px 8px 24px 0px rgba(45, 108, 252, 0.24);
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        padding: 10px 30px;
      }
    }
  }
  ::v-deep .el-checkbox__label {
    width: 100%;
    white-space: pre-wrap;
  }
}
</style>
